import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { REGION_MODAL_TEXTS } from "../../consts";
import NotFound from "./assets/NotFound.svg";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var EmptySearchResults = function EmptySearchResults() {
  return /*#__PURE__*/React.createElement("div", {
    className: cn('empty-search-results'),
    "data-t-id": "components-EmptySearchResults"
  }, /*#__PURE__*/React.createElement(NotFound, null), /*#__PURE__*/React.createElement(Text, {
    color: "primary-invert",
    size: "xs"
  }, REGION_MODAL_TEXTS.emptySearch));
};